/** @format */

import React, {useState, useEffect} from 'react';
import dot from 'dot-object';
import {useForm, parseEntityError} from 'frontier-form';
import SuperAgent from 'superagent';

/**
 * For use with a component or call the deleteAddressById function directly
 * @param onDeleteComplete
 * @param addressId
 * @param props
 * @returns {{isDeleting: boolean, onDelete: ((function(): Promise<void>)|*), setIsDeleting: (value: (((prevState: boolean) => boolean) | boolean)) => void, deleteAddressById: (function(*): Promise<*>)}}
 */
export function useAddressDelete(
    {onDeleteComplete = () => {}, addressId = false, ...props} = {onSaveComplete: () => {}}
) {
    const [isDeleting, setIsDeleting] = useState(false);

    async function deleteAddressById(addressId) {
        const endpoint = `/account/addresses/delete/${addressId}`;
        return await SuperAgent.delete(endpoint).set('accept', 'application/json');
    }

    async function onDelete() {
        setIsDeleting(true);
        try {
            const response = await deleteAddressById(addressId);

            setIsDeleting(false);
            onDeleteComplete(response);
        } catch (e) {}
    }

    return {
        isDeleting,
        setIsDeleting,
        onDelete,
        deleteAddressById
    };
}
